//imagenes clientes
import a1 from "../images/clientes_damire/1.png";
import a2 from "../images/clientes_damire/2.png";
import a3 from "../images/clientes_damire/3.png";
import a4 from "../images/clientes_damire/4.png";
import a5 from "../images/clientes_damire/5.png";
import a6 from "../images/clientes_damire/6.png";
import a7 from "../images/clientes_damire/7.png";
import a8 from "../images/clientes_damire/8.png";
import a9 from "../images/clientes_damire/9.png";
import a10 from "../images/clientes_damire/10.png";
import a11 from "../images/clientes_damire/11.png";
import a12 from "../images/clientes_damire/12.png";
import a13 from "../images/clientes_damire/13.png";
import a14 from "../images/clientes_damire/14.png";
import a15 from "../images/clientes_damire/15.png";
import a16 from "../images/clientes_damire/16.png";
import a17 from "../images/clientes_damire/17.png";
import a18 from "../images/clientes_damire/18.png";
import a19 from "../images/clientes_damire/19.png";
import a20 from "../images/clientes_damire/20.png";
import a21 from "../images/clientes_damire/21.png";
import a22 from "../images/clientes_damire/22.png";
import a23 from "../images/clientes_damire/23.png";
import a24 from "../images/clientes_damire/24.png";
import a25 from "../images/clientes_damire/25.png";
import a26 from "../images/clientes_damire/26.png";
import a27 from "../images/clientes_damire/27.png";
import a28 from "../images/clientes_damire/28.png";
import a29 from "../images/clientes_damire/29.png";
import a30 from "../images/clientes_damire/30.png";
import a31 from "../images/clientes_damire/31.png";
import a32 from "../images/clientes_damire/32.png";
import a33 from "../images/clientes_damire/33.png";
import a34 from "../images/clientes_damire/34.png";
import a35 from "../images/clientes_damire/35.png";
import a36 from "../images/clientes_damire/36.png";
export const itemsClientesHome = [
  {
    id: "a1",
    image: a1,
  },
  {
    id: "a2",
    image: a2,
  },
  {
    id: "a3",
    image: a3,
  },
  {
    id: "a4",
    image: a4,
  },
  {
    id: "a5",
    image: a5,
  },
  {
    id: "a6",
    image: a6,
  },
  {
    id: "a7",
    image: a7,
  },
  {
    id: "a8",
    image: a8,
  },
  {
    id: "a9",
    image: a9,
  },
  {
    id: "a10",
    image: a10,
  },
  {
    id: "a11",
    image: a11,
  },
  {
    id: "a12",
    image: a12,
  },
  {
    id: "a13",
    image: a13,
  },
  {
    id: "a14",
    image: a14,
  },
  {
    id: "a15",
    image: a15,
  },
  {
    id: "a16",
    image: a16,
  },
  {
    id: "a17",
    image: a17,
  },
  {
    id: "a18",
    image: a18,
  },
  {
    id: "a19",
    image: a19,
  },
  {
    id: "a20",
    image: a20,
  },
  {
    id: "a21",
    image: a21,
  },
  {
    id: "a22",
    image: a22,
  },
  {
    id: "a23",
    image: a23,
  },
  {
    id: "a24",
    image: a24,
  },
  {
    id: "a25",
    image: a25,
  },
  {
    id: "a26",
    image: a26,
  },
  {
    id: "a27",
    image: a27,
  },
  {
    id: "a28",
    image: a28,
  },
  {
    id: "a29",
    image: a29,
  },
  {
    id: "a30",
    image: a30,
  },
  {
    id: "a31",
    image: a31,
  },
  {
    id: "a32",
    image: a32,
  },
  {
    id: "a33",
    image: a33,
  },
  {
    id: "a34",
    image: a34,
  },
  {
    id: "a35",
    image: a35,
  },
  {
    id: "a36",
    image: a36,
  },
];
